import { KeyName, NameValue, NameValues } from '@/modules/neodash/model/types/interfaces/NameValue';
import { FilterService } from '@/modules/neodash/services/filterService';
import { CONFIG } from '@/config';
import { IPeriodValues } from '@/modules/neodash/model/types/interfaces/Period';
import { i18nMixin } from '@/modules/neodash/mixins';
import moment from 'moment';
import { httpService } from '@/services';
import { Loja, Stores } from '@/modules/neodash/model/types/interfaces/Stores';
import { TypeLocality } from '../model/types/interfaces/TypeLocality';
import { ServiceHelper } from '@/utils/service.helper';
import { IStoreProject } from '@/modules/dap/interfaces';
import { ClientEnum } from '@/enums/client.enum';

interface region {
  regions: string;
}

interface dealer {
  cod_dealer: number;
  dealer: string;
}

interface Location {
  id: number;
  name: string;
  geocode: number;
}

const translate = i18nMixin.methods.i18n;

const urlNeogig = `${CONFIG.URL.NEOGIG_API}`;
const reallyOldApi = `${CONFIG.URL.NEODASH_API}/api`;
const baseUrl = `${CONFIG.URL.NEODASH_API}/api`;
const baseUrlNeodashCore = `${CONFIG.URL.NEODASH_API}/api`;
const urlFilter = `${baseUrlNeodashCore}/gigDashFilters`;
const urlDash = `${baseUrlNeodashCore}/gigDash`;

type getterMapArray = (obj: NameValue) => number | string;

const getNowFormatted = (): string => moment().format('YYYY_MM_DD-hh_mm_ss');
const periodAsQueryParameter: (obj: IPeriodValues) => string = ({
  dtYearInit,
  dtMonthInit,
  dtMonthFinal,
  dtYearFinal
}) => [dtYearInit, dtMonthInit, dtYearFinal, dtMonthFinal].join('/');

const getClientName = () => {
  const clientId = sessionStorage.getItem('client') || -1;
  return ClientEnum[clientId];
};

//To Do, refactor backend and point these calls to the right place
export class FilterOldService {
  public static getTypeSales = (localityType: NameValue): Promise<NameValues> => {
    const url = `${urlFilter}/getTypeSale/${localityType.value}`;
    return FilterOldService.mapPromiseTextValue(url);
  };

  public static getStores = (ids: number[]): Promise<Stores> => {
    const url = `${urlNeogig}/Loja/GetStores?${ids.map(n => `ids=${n}`).join('&')}`;

    return FilterOldService.lojaMapper(url);
  };

  public static extractProductPMA = (obj: IPeriodValues): Promise<void> => {
    const url = `${urlDash}/extractProductPMA/${periodAsQueryParameter(obj)}`;
    const name = translate('Report.RegistrationSegmentRegionFiles.PMA');
    const nameFile = `${getClientName()}_${name}_v${moment().format('YYYYMMDD')}.xlsx`;
    return ServiceHelper.generateFile(url, nameFile, {method: 'post'});
  };

  private static lojaMapper = url =>
    ServiceHelper.mapToPromise<Loja[]>(url).then(lst =>
      lst.map(x => ({
        id: x.id,
        group: x.grupo,
        name: x.nome,
        codStoreClient: x.idLojaCliente,
        groupId: x.idGrupo
      }))
    );

  public static getToyotaStores = () => {
    const url = `${baseUrlNeodashCore}/dashboard/report/getToyotaStores`;
    return FilterOldService.lojaMapper(url);
  };

  public static getStore = (group: NameValue): Promise<NameValues> => {
    const url = `${urlFilter}/getStoreGroups/${group.value}`;

    return FilterOldService.mapPromiseKeyName(url);
  };

  public static getGroups = (): Promise<NameValues> => {
    const url = `${urlFilter}/getGroups`;
    return FilterOldService.mapPromiseKeyName(url);
  };

  public static getLocations = (ids: number[]): Promise<NameValues> => {
    const url = `${urlNeogig}/localidade/GetLocationByIds?${ids.map(n => `ids=${n}`).join('&')}`;

    return ServiceHelper.mapToPromise<any[]>(url).then(lst =>
      lst.map(x => ({
        name: x.nome,
        value: x.id
      }))
    );
  };

  public static listCitiesDealer = (): Promise<NameValues> => {
    const url = `${urlFilter}/comparisonBasket/dealer/cities`;

    return ServiceHelper.mapToPromise<Location[]>(url).then(FilterOldService.mapLocale);
  };

  public static getTypesLicensePlate = (): Promise<NameValues> => {
    const url = `${urlFilter}/getTypesLicensePlate/`;
    return FilterOldService.mapPromiseTextValue(url);
  };

  public static getTypesCompanySize = (): Promise<NameValues> => {
    const url = `${urlFilter}/getTypesCompanySize/`;
    return FilterOldService.mapPromiseTextValue(url);
  };

  public static getLocatityResolutionLevel = (): Promise<NameValues> => {
    const url = `${urlFilter}/getTypeLocalityResolutionLevel/`;
    return FilterOldService.mapPromiseTextValue(url);
  };

  public static getTypeLocalityOnlyOperationalArea = (localityLevel: NameValue): Promise<TypeLocality[]> => {
    const url = `${urlFilter}/getTypeLocality/${localityLevel.value}/onlyOperationalArea`;
    return FilterOldService.promiseTypeLocality(url);
  };

  public static getTypeLocality = (localityLevel: NameValue): Promise<TypeLocality[]> => {
    const url = `${urlFilter}/getTypeLocality/${localityLevel.value}`;
    return FilterOldService.promiseTypeLocality(url);
  };

  public static promiseTypeLocality = (url: string): Promise<TypeLocality[]> => {
    return ServiceHelper.mapToPromise<any[]>(url).then(lst =>
      lst.map(x => ({
        id: parseInt(x.id),
        name: translate(x.name),
        value: parseInt(x.id),
        virtualAreaType: x.virtualAreaType,
        resolutionLevel: x.resolutionLevel
      }))
    );
  };

  public static getLocalities = (localityType: NameValue): Promise<NameValues> => {
    const url = `${urlFilter}/getLocality/${localityType.value}`;
    return ServiceHelper.mapToPromise<Location[]>(url).then(FilterOldService.mapLocale);
  }

  public static getCitiesByGeocode = (ids: number[]): Promise<any> =>
    httpService.http.post(`${urlNeogig}/Localidade/GetCities`, ids).then(({ data }) => data);

  private static mapLocale = (lst: Location[]): NameValues =>
    lst.map(({ name, geocode }) => ({ name, value: geocode }));

  public static extractProductCity = (obj: IPeriodValues): Promise<void> => {
    const url = `${urlDash}/extractProduct/${periodAsQueryParameter(obj)}`;

    const name = translate('Report.RegistrationSegmentRegionFiles.City');
    const nameFile = `${getClientName()}_${name}_v${moment().format('YYYYMMDD')}.xlsx`;

    return ServiceHelper.generateFile(url, nameFile, {method: 'post'});
  };

  public static extractProductDistrict = (obj: IPeriodValues): Promise<void> => {
    const url = `${urlDash}/extractProductCity/${periodAsQueryParameter(obj)}`;

    const name = translate('Report.RegistrationSegmentRegionFiles.District');
    const nameFile = `${getClientName()}_${name}_v${moment().format('YYYYMMDD')}.xlsx`;

    return ServiceHelper.generateFile(url, nameFile, {method: 'post'});
  };

  private static mapQueryArray = (
    values: NameValue[],
    propName: string,
    getter: getterMapArray = x => x.value
  ): string => values.map(x => `${propName}=${getter(x)}`).join('&');

  private static mapPromiseKeyName = (url: string): Promise<NameValues> =>
    ServiceHelper.mapToPromise<KeyName[]>(url).then(lst => lst.map(x => ({ name: x.name, value: parseInt(x.id, 10) })));

  private static mapPromiseTextValue = (url: string): Promise<NameValues> =>
    ServiceHelper.mapToPromise<any[]>(url).then(lst =>
      lst.map(x => ({ name: translate(x.text), value: parseInt(x.value, 10) } as NameValue))
    );
}
